import { z } from 'zod';
import { OwnerBrandSchema, OwnerCornSchema } from '../../owner/owner.js';
import { OwnerEmailThemeSchema } from '../../owner/theme.js';
export const GetOwnerEmailBrandingApiSchema = {
    params: z.object({
        ownerId: OwnerCornSchema,
    }),
    response: OwnerBrandSchema.pick({
        assets: true,
        emailEnvelope: true,
        footer: true,
    }).extend({
        /** Only the email half of the owner's theme - the ui half never reaches MJML. */
        theme: OwnerEmailThemeSchema,
    }),
};
export const GetOwnerEmailBrandingPathSchema = GetOwnerEmailBrandingApiSchema.params;
export const GetOwnerEmailBrandingRequestSchema = GetOwnerEmailBrandingPathSchema;
export const GetOwnerEmailBrandingResponseSchema = GetOwnerEmailBrandingApiSchema.response;
